
import TimeCollection from '@/components/TimeCollection.vue';
import copy from 'copy-to-clipboard'
import store from '@/store';
import Vue from 'vue'
import CostGuardNotice from '@/components/CostGuardNotice.vue'
import IntroDrawer from '@/components/IntroDrawer.vue'
import { introContext, publicIntro, introButtonText, resultsRendered } from '@/utils/intro'
import { costGuardCode } from '@/utils/guestSession'
import { CreatePollForMatchInput, EmailSendInput, ExecuteMatchingInput, FiltersInput, KeywordProcessContentInput, Match, MatchFiltersDto, MatchMatchDirectionEnum, MatchRequest, MatchResultsDto, ProfileUpdatedRequest, RecommendedAction, SendMarkdownEmailInput, SharingRequest, SyncUnitToUserInput, Unit, UnitDto, UpdateAvailabilityTimeInput, UserDto, UserDtoBindingStatusEnum, UserSavedContactCreation } from '@chainsight/networker-backend-axios-sdk';
import { Editor } from '@toast-ui/vue-editor';
import { zonedTimeToUtc, formatInTimeZone } from 'date-fns-tz';
import { format, startOfWeek, addWeeks, setHours, setMinutes, setSeconds, addDays, isAfter } from 'date-fns';
import i18n from '@/plugins/i18n'
import { translateTexts, translateMatches, translateRecordValues, translateMatch } from '@/utils/translator'
import { it } from 'date-fns/locale';

export default Vue.extend({
	name: 'BusinessMatchResults',
	components: { CostGuardNotice, IntroDrawer,
		editor: Editor,
		TimeCollection
	},
	data() {
		return {
            costCode: '',
            introOpen: false,
            introContextData: {} as any,
			MatchMatchDirectionEnum,
			overlay: false,
            matchContextReady: Promise.resolve() as Promise<void>,
            publicResultSequence: 0,
            publicResultsDestroyed: false,
			isSearchLoading: false,
			progressValue: 0,
			progressStatusText: '',
			progressInterval: null as any,
			emailDialog: false,
			isCopied: false,
			isRequiredImageError: false,
			isFilterBarOpen: true,
			detailDrawer: false,
			mobileDetailDrawer: false,
			isFilterDialogOpen: false,
			searchDialog: false,
			searchKeyword: '',
			isSearchingFromDialog: false,
			emailSuccessDialog: false,
			timeCollectionDialog: false,
			onboardingDialog: false,
			profileReminderSnackbar: false,
			pendingProfileReminderSnackbar: false,
			onboardingStep: 1,
			sharingDialog: false,
			isSupplyDescExpanded: false,
			isDemandDescExpanded: false,
			isHasStructuredProfile: 'all',
			fullName: '',
			jobTitle: '',
			companyName:'',
			companyWebsiteUrl: '',
			currentEmail: '',
			phone: '',
			bio: '',
			industry: [] as string[],
			industrySearchText: '',
			industryFilteredList: [] as string[],
			translatedToOriginalIndustryMap: {} as Record<string, string>,
			emailContentMarkdownForEdit: '',
			sharingUrl: '',
			countriesUpperBound: 3,
			industriesUpperBound: 3,
			matchDirectionsUpperBound: 3,
			matchQueriesUpperBound: 3,
			regionsUpperBound: 3,
			typesUpperBound: 3,
			timeStrings: [] as string[],
			utcTimeStrings: [] as string[],
			demandDescriptions: [] as string[],
			supplyDescriptions: [] as string[],
			countries: [] as string[],
			industries: [] as string[],
			matchDirections: [] as string[],
			matchQueries: [] as string[],
			regions: [] as string[],
			types: [] as string[],
			allCountries: [] as string[],
			allMatchQueries: [] as string[],
			allIndustries: [] as string[],
			platformIndustries: [] as string[],
			allRegions: [] as string[],
			allTypes: [] as string[],
			matchRequest: {} as MatchRequest,
			matchFilterDto: {} as MatchFiltersDto,
			facetDto: {} as any,
			countryKeyValue: {} as Record<string, string>,
			industryKeyValue: {} as Record<string, string>,
			platformIndustryKeyValue: {} as Record<string, string>,
			queryKeyValue: {} as Record<string, string>,
			regionKeyValue: {} as Record<string, string>,
			typeKeyValue: {} as Record<string, string>,
			matchResultDetail: {
				unit: {
					id: 0,
					community: [] as {
						url: string,
						platform: string
					}[],
				}
			} as Match,
			community: [] as {
				url: string,
				platform: string
			}[],
			booths: [] as { 
				url: string
				name: string 
			}[],
			contactList: [] as UnitDto[],
			contactListRefactor: [] as {
				firstName: string,
				lastName: string,
				title: string[],
				email: string,
				mobilePhone: string,
				community: {
					url: string | null,
					platform: string | null
				}[]
			}[],
			userDto: { ...((!store.state.track.trackDto?.id || store.state.track.trackDto.id === '0') ? (store.state.user.userDto || {}) : {}) } as UserDto,
			matchResults: {} as MatchResultsDto,
			profileReminderDialog: false,
			currentPage: 0,
			pageSize: 10,
			isLoadingMore: false,
			hasMorePages: true,
			recommendedAction: {} as RecommendedAction,
			sharingRequest: {} as SharingRequest,
			availabilitySettings: {
				timezone: "",
				availableDays: {
					monday: false,
					tuesday: false,
					wednesday: false,
					thursday: false,
					friday: false,
					saturday: false,
					sunday: false,
				},
				availableHours: {
					monday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					tuesday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					wednesday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					thursday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					friday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					saturday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
					sunday: {
						0: false, 1: false, 2: false, 3: false, 4: false, 5: false, 6: false, 7: false, 8: false, 
						9: false, 10: false, 11: false, 12: false, 13: false, 14: false, 15: false, 16: false, 
						17: false, 18: false, 19: false, 20: false, 21: false, 22: false, 23: false
					},
				},
				meetingDuration: 60,
				repeatWeeks: 0,
				lastUpdated: 0
			},
			editorOptions: {
				hideModeSwitch: true,
				toolbarItems: [
					['heading', 'bold', 'italic', 'strike'],
					['hr', 'quote'],
					['ul', 'ol', 'task', 'indent', 'outdent'],
					['table', 'link'],
					['code', 'codeblock'],
					['scrollSync'],
				]
			},
			// 發送信件相關
			sendEmailDialog: false,
			sendEmailSubject: '',
			sendEmailContent: '',
			sendEmailSharingUrl: '',
			sendEmailFixedContent: '',
			sendEmailLoading: false,
			// Snackbar
			snackbar: false,
			snackbarText: '',
			snackbarColor: '#1976D1',
			snackbarLinkText: '',
			snackbarLinkRoute: '',
			snackbarTextAfter: ''
		};
	},
	computed: {
        isPublicIntro(): boolean { return publicIntro(this.trackDto?.id, this.userDto?.isPaidMember) },
        introLabel(): string { return introButtonText(this.$vuetify.breakpoint.xs) },
		trackDto(){
			return store.state.track.trackDto
		},
		user() {
			return store.state.user;
		},
		industryItemsLimited(): { text: string; value: string; disabled: boolean }[] {
			const industryList: string[] = Array.isArray(this.industry) ? this.industry : [];
			const isMax = industryList.length >= 5;
			const baseList: string[] = this.industrySearchText?.length > 0
				? (this.industryFilteredList ?? []) : (this.platformIndustries || []);

			return baseList.map((item: string) => ({
				text: item,
				value: item,
				disabled: isMax && !this.industry.includes(item),
			}));
		},
	},
	methods: {
        async openIntroForm(item: any, source = 'results_drawer') {
            await this.matchContextReady;
            if (this.publicResultsDestroyed) return;
            this.detailDrawer = false; this.mobileDetailDrawer = false
            this.introContextData = introContext(item, this.matchRequest, '', source)
            this.introOpen = true
        },
		capitalizeFirst(text: string): string {
			if (!text) return ''
			return text.charAt(0).toUpperCase() + text.slice(1)
		},
		async handleSearchFromDialog() {
			if (!this.searchKeyword?.trim()) return
			this.searchDialog = false
			this.onSearchStarted()

			try {
				const keywordProcessContentInput: KeywordProcessContentInput = {
					keyword: this.searchKeyword,
				}

				const keywordProcessContentResp = await this.api$.businessMatchApi.keywordProcessContent(
					this.user.userDto?.id as string,
					this.trackDto?.id ? this.trackDto.id : '0',
					keywordProcessContentInput
				)
				const matchRequest = keywordProcessContentResp.data.data
				if (!matchRequest) return

				if (!matchRequest.simplifiedDemands?.length && !matchRequest.simplifiedSupplies?.length) {
					this.onSearchFinished()
					this.$router.push({ name: 'BusinessMatchContent' })
					return
				}

				const executeMatchingInput: ExecuteMatchingInput = {
					simplifiedDemands: matchRequest.simplifiedDemands,
					simplifiedSupplies: matchRequest.simplifiedSupplies,
				}

				await this.api$.businessMatchApi.executeMatching(
					this.user.userDto?.id as string,
					this.trackDto?.id ? this.trackDto.id : '0',
					executeMatchingInput
				)

				window.location.reload()
			} catch (error: any) {
                this.costCode = costGuardCode(error)
				console.error(error)
				this.onSearchFinished()
			}
		},
		onSearchStarted() {
			this.isSearchLoading = true
			this.progressValue = 0
			this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))

			// 啟動進度條動畫 - 15秒分成4等份
			let startTime = Date.now()

			this.progressInterval = setInterval(() => {
				const elapsed = Date.now() - startTime
				const timer = elapsed / 1000 // 轉換為秒

				if (timer >= 15) {
					// 超過15秒，保持在99%
					this.progressValue = 99
					return
				}

				if (timer <= 3.75) {
					// 第一等分：分析您的需求
					this.progressStatusText = String(this.$t('common.progressStatus.analyzingRequest'))
					this.progressValue = (timer / 3.75) * 24.75  // 0-24.75%
				} else if (timer > 3.75 && timer <= 7.5) {
					// 第二等分：搜尋相關成員
					this.progressStatusText = String(this.$t('common.progressStatus.searchingMembers'))
					this.progressValue = 24.75 + ((timer - 3.75) / 3.75) * 24.75  // 24.75-49.5%
				} else if (timer > 7.5 && timer <= 11.25) {
					// 第三等分：智慧配對中
					this.progressStatusText = String(this.$t('common.progressStatus.smartMatching'))
					this.progressValue = 49.5 + ((timer - 7.5) / 3.75) * 24.75  // 49.5-74.25%
				} else if (timer > 11.25 && timer <= 15) {
					// 第四等分：生成結果
					this.progressStatusText = String(this.$t('common.progressStatus.generatingResults'))
					this.progressValue = 74.25 + ((timer - 11.25) / 3.75) * 24.75  // 74.25-99%
				}
			}, 100)  // 每100ms更新一次，讓動畫更平滑
		},
		onSearchFinished() {
			// 完成動畫 - 與 UserProfile.vue 相同的邏輯
			this.progressValue = 100
			clearInterval(this.progressInterval)
			setTimeout(() => {
				this.isSearchLoading = false
				this.progressValue = 0
				this.progressStatusText = ''
			}, 500)
		},
		async clearAllFilters() {
			this.overlay = true
			this.countries = []
			this.industries = []
			this.matchQueries = []
			this.regions = []
			this.isHasStructuredProfile = 'all'
			
			// 重置分頁狀態
			this.currentPage = 0
			this.hasMorePages = true
			
			await Promise.all([
				this.getMatches(),
				this.getFilterList()
			])
			this.overlay = false
		},
		async handleFilterChange() {
			await Promise.all([
				this.getFilterList(),
				this.refine()
			])
		},
		handleScroll(event) {
			// 非付費會員不觸發載入更多（track 20 除外）
			if (this.userDto.isPaidMember === false && this.trackDto?.id !== '20') {
				return;
			}

			const element = event.target;
			const scrollHeight = element.scrollHeight;
			const scrollTop = element.scrollTop;
			const clientHeight = element.clientHeight;

			// 當滾動到底部附近時觸發載入更多
			if (scrollHeight - scrollTop <= clientHeight + 100) {
				this.loadMore();
			}
		},
		smoothScrollToTop() {
			const desktopContainer = this.$refs.desktopListContainer as HTMLElement;
			const mobileContainer = this.$refs.mobileListContainer as HTMLElement;
			const container = desktopContainer || mobileContainer;
			
			if (container) {
				const scrollDuration = 500; // 動畫持續時間（毫秒）
				const startPosition = container.scrollTop;
				const startTime = performance.now();
				
				const easeInOutQuad = (t: number) => {
					return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
				};
				
				const animateScroll = (currentTime: number) => {
					const elapsed = currentTime - startTime;
					const progress = Math.min(elapsed / scrollDuration, 1);
					const easeProgress = easeInOutQuad(progress);
					
					container.scrollTop = startPosition * (1 - easeProgress);
					
					if (progress < 1) {
						requestAnimationFrame(animateScroll);
					}
				};
				
				requestAnimationFrame(animateScroll);
			}
		},
		hasActiveFilters() {
			return (this.countries && this.countries.length > 0) ||
				(this.industries && this.industries.length > 0) ||
				(this.matchQueries && this.matchQueries.length > 0) ||
				(this.regions && this.regions.length > 0) ||
				this.isHasStructuredProfile !== 'all';
		},
		async loadMore() {
			// 非付費會員不允許載入更多（track 20 除外）
			if (this.userDto.isPaidMember === false && this.trackDto?.id !== '20') return;
			if (this.isLoadingMore || !this.hasMorePages) return;

			// 根據是否有篩選條件來決定使用哪個方法
			if (this.hasActiveFilters()) {
				await this.refine(true);
			} else {
				await this.getMatches(true);
			}
		},
		normalizedWebsite(url: string) {
			if (!url) return ''; // 沒有網址就回傳空字串
			if (/^https?:\/\//i.test(url)) {
				return url;
			}
			return 'https://' + url;
		},
		async getMe(){
			try {
				const resp = await this.api$.authApi.getMe();
				this.userDto = resp.data.data as UserDto;

				this.fullName = (this.userDto.firstName || this.userDto.lastName)
								? [this.userDto.firstName, this.userDto.lastName].filter(Boolean).join(' ')
								: ''
				this.jobTitle = this.userDto.companyTitle?.join(', ') ?? '';
				this.companyName = this.userDto.companyName ?? '';
				this.companyWebsiteUrl = this.userDto.companyUrl?.split('https://')[1] ?? '';
				this.currentEmail = this.userDto.currentEmail ?? '';
				this.phone = this.userDto.phone ?? '';
			this.bio = this.userDto.bioDescription ?? '';
				this.industries = this.userDto.companyIndustry ?? [];
				// 保留英文行業名稱，稍後在 created() 中轉換（等 getPlatformIndustryList() 完成後）

				if(this.userDto.bindingStatus === UserDtoBindingStatusEnum.Unbound){
					// 先呼叫 syncUnitToUser API
					const syncUnitToUserInput: SyncUnitToUserInput = {
						email: this.userDto.email,
						productTrackId: this.trackDto?.id,
					}
					const syncResp = await this.api$.profileApi.syncUnitToUser(this.userDto.id as string, syncUnitToUserInput)
					this.userDto = syncResp.data.data ?? this.userDto
					store.commit('SET_USER_DTO', this.userDto)

					if(this.userDto.bindingStatus === UserDtoBindingStatusEnum.Bound){
						this.pendingProfileReminderSnackbar = true
					}
				}

				if(this.userDto.bindingStatus !== UserDtoBindingStatusEnum.Bound && this.userDto.bindingStatus !== UserDtoBindingStatusEnum.NotRequired && (this.fullName.length == 0 || this.phone.length == 0 || this.currentEmail.length == 0)){
					this.onboardingDialog = true
				}
			} catch (e) {
				console.error(e);
			}
		},
		copy(text) {
			copy(text)
			this.isCopied = true
			setTimeout(() => {
				this.isCopied = false
			}, 1000)
		},
		scrollToMatch(matchId: string){
			this.$nextTick(() => {
					const el = document.getElementById('match-' + matchId)
					if (el) {
							el.scrollIntoView({ behavior: 'smooth', block: 'start' })
					}
			})
		},
		async share(){
			this.overlay = true
			let createResp
			try {
				let filterInput: FiltersInput = {
					countriesIso3: this.countries,
					industries: this.industries,
					queries: this.matchQueries,
					regions: this.regions,
					...(this.isHasStructuredProfile !== 'all' && {
						hasStructuredProfile: this.isHasStructuredProfile === 'true'
					})
				}

				filterInput.countriesIso3 = Object.entries(this.countryKeyValue ?? {})
					.filter(([key, value]) => this.countries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				filterInput.industries = Object.entries(this.industryKeyValue ?? {})
					.filter(([key, value]) => this.industries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});
				
				filterInput.queries = Object.entries(this.queryKeyValue ?? {})
					.filter(([key, value]) => this.matchQueries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				filterInput.regions = Object.entries(this.regionKeyValue ?? {})
					.filter(([key, value]) => this.regions?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});
				
				createResp = await this.api$.sharingApi.create1(this.matchRequest.id as string, filterInput)
				this.sharingRequest = createResp.data.data

				this.sharingUrl = window.location.origin + '/nl-match/sharing/' + this.sharingRequest.id
				this.sharingDialog = true
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
			this.overlay = false
		},
		async handleSaveFromChild(payload) {
			this.overlay = true
			this.availabilitySettings = payload;

			const updateAvailabilityTimeInput : UpdateAvailabilityTimeInput = {
				availabilityTime: this.availabilitySettings
			}

			let updateAvailabilityTimeResp
			try {
				updateAvailabilityTimeResp = await this.api$.profileApi.updateAvailabilityTime(this.user.userDto?.id as string, updateAvailabilityTimeInput)
				this.userDto = updateAvailabilityTimeResp.data.data
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}

			// 處理時間
			const result: string[] = []
			const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
			const now = new Date()
			const thisWeekStart = startOfWeek(now, { weekStartsOn: 0 })
			// const repeatWeeks = this.availabilitySettings.repeatWeeks ?? 1;

			// 清空之前的資料，避免重複
			this.timeStrings = [];
			this.utcTimeStrings = [];

			for (let weekOffset = 0; weekOffset < this.availabilitySettings.repeatWeeks; weekOffset++) {
				for (let dayIndex = 0; dayIndex < 7; dayIndex++) {
					const dayName = daysOfWeek[dayIndex]
					if (!this.availabilitySettings.availableDays[dayName]) continue;
					const hoursMap = this.availabilitySettings.availableHours[dayName]
					if (!hoursMap) continue

					for (let hour = 0; hour < 24; hour++) {
						if (!hoursMap[hour]) continue

						const date = setSeconds(
						setMinutes(setHours(addDays(addWeeks(thisWeekStart, weekOffset), dayIndex), hour),0),0)

						// 只取比現在晚的時間
						if (isAfter(date, now)) {
							result.push(format(date, 'yyyy-MM-dd HH:mm'))
						}
					}
				}
			}

			this.timeStrings = result;

			this.timeStrings.map(timeStr => {
				const date = zonedTimeToUtc(timeStr, this.availabilitySettings.timezone);
				this.utcTimeStrings.push(formatInTimeZone(date, "UTC", "yyyy-MM-dd HH:mm"));
			});

			this.timeCollectionDialog = false;
			this.emailDialog = false;

			const createPollForMatchInput : CreatePollForMatchInput = {
				userEmail: this.user.userDto?.email,
				to: this.matchResultDetail.unit?.email,
				matchId: this.matchResultDetail.id,
				timeStrings: this.utcTimeStrings
			}

			let recommendedAction
			try{
				recommendedAction = await this.api$.businessMatchApi.createPollForMatch(this.user.userDto?.id as string, createPollForMatchInput)
				this.recommendedAction = recommendedAction.data.data

				const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
				if(editorInstance){
					if(this.trackDto?.id == '7'){
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
						this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
					}
					editorInstance.invoke('setMarkdown', this.recommendedAction.text as string);
				}else{
					if(this.trackDto?.id == '7'){
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
						this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
						this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
					}
					this.emailContentMarkdownForEdit = this.recommendedAction.text as string
				}
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
			
			this.emailDialog = true;
			this.overlay = false
		},
		handleEditorChange() {
			const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
			this.emailContentMarkdownForEdit = editorInstance.invoke('getMarkdown');
		},
		onImageError(item : Match) {
			if (item.unit && item.unit.entityName) {
				const firstLetter = item.unit.entityName.substring(0, 1).toUpperCase();
				item.unit.avatarUrl = require(`@/assets/business-match/alphabet/alphabet=${firstLetter}.png`);
			} else if(item.unit) {
				item.unit.avatarUrl = require('@/assets/business-match/alphabet/alphabet=Other.png');
			}
		},
		nextStep() {
			this.onboardingStep = 2;
		},
		previousStep() {
			this.onboardingStep = 1;
		},
		filterIndustries() {
			if (!this.industrySearchText || this.industrySearchText.trim() === '') {
				this.industryFilteredList = [];
				return;
			}

			const searchLower = this.industrySearchText.toLowerCase();
			this.industryFilteredList = this.platformIndustries.filter((industry: string) =>
				industry.toLowerCase().includes(searchLower)
			);
		},
		convertIndustryToCurrentLanguage(englishIndustries: string[]): string[] {
			if (!englishIndustries || englishIndustries.length === 0) {
				return []
			}

			return englishIndustries.map(englishIndustry => {
				// 從 industryKeyValue 找到對應的翻譯
				// industryKeyValue 的 key 是英文原文，value 是翻譯後的文字
				return this.industryKeyValue[englishIndustry] || englishIndustry
			})
		},
		async getPlatformIndustryList() {
			let getFilterListResp
			try {
				getFilterListResp = await this.api$.platformApi.getFilterList()
				this.facetDto = getFilterListResp.data.data

				this.platformIndustryKeyValue = this.normalizeToKeyValue(this.facetDto.industries) ?? {}

				if (i18n.locale === 'zh') {
					await translateRecordValues(this.platformIndustryKeyValue, 'zh-Hant')
				} else if (i18n.locale === 'en') {
					await translateRecordValues(this.platformIndustryKeyValue, 'en-US')
				} else if (i18n.locale === 'ja') {
					await translateRecordValues(this.platformIndustryKeyValue, 'ja-JP')
				}

				this.platformIndustries = Object.values(this.platformIndustryKeyValue ?? {})

				// 建立反向 map：翻譯後的文字 -> 英文原文
				this.translatedToOriginalIndustryMap = {}
				for (const [originalKey, translatedValue] of Object.entries(this.platformIndustryKeyValue)) {
					this.translatedToOriginalIndustryMap[translatedValue] = originalKey
				}
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error)
			}
		},
		normalizeToKeyValue(data: any): Record<string, string> | undefined {
			if (Array.isArray(data)) {
				return data.reduce((acc: Record<string, string>, item: any) => {
					if (typeof item === 'string') {
						acc[item] = item;
					}
					return acc;
				}, {});
			}
			return undefined;
		},
		async completeOnboarding() {
			this.overlay = true;
			this.onboardingDialog = false;

			// 儲存更新前的狀態
			const beforeIsPaidMember = this.userDto?.isPaidMember || false
			const beforeIsFreeUpgradeUsed = this.userDto?.isFreeUpgradeUsed || false

			// 將翻譯後的行業名稱轉換回英文原文
			const industryInEnglish = this.industry?.map(translatedIndustry => {
				return this.translatedToOriginalIndustryMap[translatedIndustry] || translatedIndustry
			}) || [];

			const profileUpdatedRequest: ProfileUpdatedRequest = {
				firstName: this.fullName,
				lastName: '',
				companyName: this.companyName,
				companyUrl: this.companyWebsiteUrl?.trim() ? 'https://' + this.companyWebsiteUrl.trim() : '',
				companyTitle: this.jobTitle?.trim()
					? this.jobTitle.split(',').map(t => t.trim()).filter(Boolean)
					: undefined,
				companyIndustry: industryInEnglish,
				currentEmail: this.currentEmail,
				bioDescription: this.bio,
				phone: this.phone,
				productTrackId: this.trackDto?.id,
				isDelete: this.userDto?.isDelete,
			};

			try {
				const updateProfileResp = await this.api$.profileApi.updateProfile(this.user.userDto?.id as string, profileUpdatedRequest);
				if (updateProfileResp.data.data) {
					this.userDto = updateProfileResp.data.data;
				}

				// const enhanceUserProfileResp = await this.api$.profileApi.enhanceUserProfile(this.user.userDto?.id as string, '0');
				// if (enhanceUserProfileResp.data.data) {
				// 	this.userDto = enhanceUserProfileResp.data.data;
				// }

				// 檢查是否從 false 變成 true
				const afterIsPaidMember = this.userDto?.isPaidMember || false
				const afterIsFreeUpgradeUsed = this.userDto?.isFreeUpgradeUsed || false

				if (!beforeIsPaidMember && afterIsPaidMember && !beforeIsFreeUpgradeUsed && afterIsFreeUpgradeUsed) {
					// 觸發事件顯示 free trial banner
					this.eventHub$.$emit('showFreeTrialBanner')
					// 同時觸發 AvatarMenu 更新會員狀態
					this.eventHub$.$emit('avatarMenuGetUser')

					this.getMatches()
				}
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}

			// 若 bindingStatus 是 cannot_bind，用 onboarding 填的 email 再打一次 syncUnitToUser API
			if(this.userDto.bindingStatus === UserDtoBindingStatusEnum.CannotBind){
				try {
					const syncUnitToUserInput: SyncUnitToUserInput = {
						email: this.currentEmail,
						productTrackId: this.trackDto?.id,
					}
					const syncResp = await this.api$.profileApi.syncUnitToUser(this.userDto.id as string, syncUnitToUserInput)
					this.userDto = syncResp.data.data ?? this.userDto
					store.commit('SET_USER_DTO', this.userDto)

					if(this.userDto.bindingStatus === UserDtoBindingStatusEnum.Bound){
						this.profileReminderSnackbar = true
					}
				} catch (error) {
                this.costCode = costGuardCode(error)
					console.error(error)
				}
			}

			this.overlay = false;
		},
		async getMatchRequest(){
			try {
				let getMatchRequestResp
				getMatchRequestResp = await this.api$.businessMatchApi.getMatchRequest(this.user.userDto?.id as string, this.trackDto?.id? this.trackDto.id : '0')
				this.matchRequest = getMatchRequestResp.data.data
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
		},
		async getMatches(isLoadMore = false, shouldScroll = true){
			if (this.isLoadingMore) return;
			if (isLoadMore && !this.hasMorePages) return;
			
			if (isLoadMore) {
				this.isLoadingMore = true;
				this.currentPage++;
			} else {
				this.overlay = true;
				this.currentPage = 0;
				this.hasMorePages = true;
			}
			
			let getMatchesResp
			try {
				getMatchesResp = await this.api$.businessMatchApi.getMatchesPaginated(
					this.user.userDto?.id as string, 
					this.trackDto?.id? this.trackDto.id : '0',
					this.currentPage,
					this.pageSize
				)
				
				const newData = getMatchesResp.data.data;
				
				if (isLoadMore) {
					// 追加新資料到現有列表
					if (newData.content && newData.content.length > 0) {
						this.matchResults.matches = (this.matchResults.matches || []).concat(newData.content);
					}
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				} else {
					// 第一次載入或重新載入
					this.matchResults.matches = newData.content || [];
                    resultsRendered(this.trackDto?.id, newData.content?.length || 0);

					this.hasMorePages = newData.content && newData.content.length === this.pageSize;

					// 只有在 shouldScroll 為 true 時才滾動到頂部
					if (shouldScroll) {
						this.$nextTick(() => {
							this.smoothScrollToTop();
						});
					}
				}

				// 處理新載入的資料
				const matchesToProcess = isLoadMore ? newData.content : this.matchResults.matches;
				matchesToProcess?.forEach(match => {
					if (match.unit?.tags) {
						const parsed: any = JSON.parse(JSON.stringify(match.unit.tags));
						const chapterValue = parsed.chapter;
						const regionValue = parsed.region;
						const typeValue = parsed.type;

						match.unit.tags = JSON.parse(
							JSON.stringify({
								...(chapterValue != null && { chapter: chapterValue }),
								...(regionValue != null && { region: regionValue }),
								...(typeValue != null && { type: typeValue })
							})
						);
					}
				});

                // Public results are complete before optional presentation translation.
                if (!this.trackDto?.id || this.trackDto.id === '0') {
                    void this.translatePublicResultPage(matchesToProcess || []);
                } else if (i18n.locale === 'zh') {
					await translateMatches(matchesToProcess || [], 'zh-Hant')
				} else if (i18n.locale === 'en') {
					await translateMatches(matchesToProcess || [], 'en-US')
				} else if (i18n.locale === 'ja') {
					await translateMatches(matchesToProcess || [], 'ja')
				}

			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error fetching get matches:', error);
			} finally {
				if (isLoadMore) {
					this.isLoadingMore = false;
				} else {
					this.overlay = false;
				}
			}
		},
        async translatePublicResultPage(matches: Match[]) {
            if (!matches.length) return;
            const originals = matches.slice();
            const userId = this.user.userDto?.id, trackId = this.trackDto?.id || '0';
            const locale = i18n.locale, sequence = this.publicResultSequence;
            const language = locale === 'zh' ? 'zh-Hant' : locale === 'ja' ? 'ja' : 'en-US';
            try {
                const translated: Match[] = JSON.parse(JSON.stringify(originals));
                await translateMatches(translated, language);
                if (this.publicResultsDestroyed || sequence !== this.publicResultSequence || i18n.locale !== locale
                    || this.user.userDto?.id !== userId || (this.trackDto?.id || '0') !== trackId) return;
                originals.forEach((original, offset) => {
                    const index = this.matchResults.matches?.indexOf(original) ?? -1;
                    if (index >= 0 && this.matchResults.matches) this.$set(this.matchResults.matches, index, translated[offset]);
                });
            } catch { /* Complete original results remain usable. */ }
        },
		async insertMatchResultDetail(match : Match){
			this.overlay = true
			this.matchResultDetail = match
			this.community = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.community)) as { url: string; platform: string }[]
			this.booths = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.booths)) as { url: string; name: string }[]
			const allowedPlatforms = ['linkedin', 'twitter', 'whatsapp', 'github'];
			if(this.community){
				this.community = this.community.filter(item => {
					return allowedPlatforms.includes(item.platform);
				});
			}
			this.demandDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.demands || "[]")).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
			this.supplyDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.supplies || "[]")).map((s) => s.description ?? s.description_short ?? s.descriptionShort);

			if(this.matchResultDetail.summaries && this.matchResultDetail.summaries.length > 0){
				this.detailDrawer = true
				this.mobileDetailDrawer = true
			} else {
				while(this.matchResultDetail.summaries == null || this.matchResultDetail.summaries?.length == 0){
					await this.getMatch(this.matchResultDetail.id as string)

					// 等待 1 秒
					await new Promise(resolve => setTimeout(resolve, 1000));
				}

				if (i18n.locale === 'zh') {
					await translateMatch(this.matchResultDetail, 'zh-Hant')
					this.demandDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.demands || "[]")).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
					this.supplyDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.supplies || "[]")).map((s) => s.description ?? s.description_short ?? s.descriptionShort);
				} else if (i18n.locale === 'en') {
					await translateMatch(this.matchResultDetail, 'en-US')
					this.demandDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.demands || "[]")).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
					this.supplyDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.supplies || "[]")).map((s) => s.description ?? s.description_short ?? s.descriptionShort);
				} else if (i18n.locale === 'ja') {
					await translateMatch(this.matchResultDetail, 'ja')
					this.demandDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.demands || "[]")).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
					this.supplyDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.supplies || "[]")).map((s) => s.description ?? s.description_short ?? s.descriptionShort);
				}
				
				this.detailDrawer = true
				this.mobileDetailDrawer = true
				this.getMatches(false, false) // 不要載入更多，也不要滾動
			}
			this.overlay = false
		},
		async getMatch(matchId: string){
			let getMatchResp
			try{
				getMatchResp = await this.api$.businessMatchApi.getMatch(this.user.userDto?.id as string, matchId)
				this.matchResultDetail = getMatchResp.data.data
				this.community = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.community)) as { url: string; platform: string }[]
				this.booths = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.booths)) as { url: string; name: string }[]
				const allowedPlatforms = ['linkedin', 'twitter', 'whatsapp', 'github'];
				if(this.community){
					this.community = this.community.filter(item => {
						return allowedPlatforms.includes(item.platform);
					});
				}
				this.demandDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.demands || "[]")).map((d) => d.description ?? d.description_short ?? d.descriptionShort);
				this.supplyDescriptions = JSON.parse(JSON.stringify(this.matchResultDetail.unit?.supplies || "[]")).map((s) => s.description ?? s.description_short ?? s.descriptionShort);

				if (this.matchResultDetail.unit?.tags) {
					const parsed: any = JSON.parse(JSON.stringify(this.matchResultDetail.unit.tags));
					const chapterValue = parsed.chapter;
					const regionValue = parsed.region;
					const typeValue = parsed.type;
					this.matchResultDetail.unit.tags = JSON.parse(
						JSON.stringify({
							...(chapterValue != null && { chapter: chapterValue }),
							...(regionValue != null && { region: regionValue }),
							...(typeValue != null && { type: typeValue })
						})
					)
				}
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error fetching get match by Id:', error);
				return undefined;
			}
		},
		async getContactList(unitId : number){
			let getContactListResp
			try{
				getContactListResp = await this.api$.businessMatchApi.getContactList(this.user.userDto?.id as string, unitId)
				this.contactList = getContactListResp.data.data

				const allowedPlatforms = ['linkedin', 'twitter', 'whatsapp', 'github'];
				this.contactListRefactor = this.contactList.map(item => {
					if(this.community){
						this.community = this.community.filter(item => {
							return allowedPlatforms.includes(item.platform);
						});
					}
					return {
						firstName: item.firstName as string,
						lastName: item.lastName as string,
						title: item.title as string[],
						email: item.email as string,
						mobilePhone: item.mobilePhone as string,
						community: JSON.parse(JSON.stringify(item.community)).filter(item => {
							return allowedPlatforms.includes(item.platform);
						}) as { url: string | null; platform: string | null }[]
					}
				})
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error fetching get contact list:', error);
			}
		},
		goToProfile() {
			this.profileReminderDialog = false;
			this.$router.push('/profile');
		},
		async refine(isLoadMore = false, shouldScroll = true){
			if (this.isLoadingMore) return;
			if (isLoadMore && !this.hasMorePages) return;
			
			if (isLoadMore) {
				this.isLoadingMore = true;
				this.currentPage++;
			} else {
				this.overlay = true;
				this.currentPage = 0;
				this.hasMorePages = true;
			}

			let filterInput: FiltersInput = {
				countriesIso3: this.countries,
				industries: this.industries,
				queries: this.matchQueries,
				regions: this.regions,
				types: this.types,
				...(this.isHasStructuredProfile !== 'all' && {
					hasStructuredProfile: this.isHasStructuredProfile === 'true'
				})
			}

			filterInput.countriesIso3 = Object.entries(this.countryKeyValue ?? {})
				.filter(([key, value]) => this.countries?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			filterInput.industries = Object.entries(this.industryKeyValue ?? {})
				.filter(([key, value]) => this.industries?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			filterInput.queries = Object.entries(this.queryKeyValue ?? {})
				.filter(([key, value]) => this.matchQueries?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			filterInput.regions = Object.entries(this.regionKeyValue ?? {})
				.filter(([key, value]) => this.regions?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			filterInput.types = Object.entries(this.typeKeyValue ?? {})
				.filter(([key, value]) => this.types?.includes(value))
				.map(([key]) => {
					const match = key.match(/^(.+?) \((\d+)\)$/)
					return match ? match[1] : key
				});

			let getMatchesWithFiltersResp
			try {
				getMatchesWithFiltersResp = await this.api$.businessMatchApi.getMatchesWithFiltersPaginated(
					this.user.userDto?.id as string,
					filterInput,
					this.trackDto?.id? this.trackDto.id : '0',
					this.currentPage,
					this.pageSize
				)
				
				const newData = getMatchesWithFiltersResp.data.data;
				
				if (isLoadMore) {
					// 追加新資料到現有列表
					if (newData.content && newData.content.length > 0) {
						this.matchResults.matches = (this.matchResults.matches || []).concat(newData.content);
					}
					this.hasMorePages = newData.content && newData.content.length === this.pageSize;
				} else {
					// 第一次載入或重新載入
					this.matchResults.matches = newData.content || [];
                    resultsRendered(this.trackDto?.id, newData.content?.length || 0);

					this.hasMorePages = newData.content && newData.content.length === this.pageSize;

					// 只有在 shouldScroll 為 true 時才滾動到頂部
					if (shouldScroll) {
						this.$nextTick(() => {
							this.smoothScrollToTop();
						});
					}
				}

				// 處理新載入的資料
				const matchesToProcess = isLoadMore ? newData.content : this.matchResults.matches;
				matchesToProcess?.forEach(match => {
					if (match.unit?.tags) {
						const parsed: any = JSON.parse(JSON.stringify(match.unit.tags));
						const chapterValue = parsed.chapter;
						const regionValue = parsed.region;
						const typeValue = parsed.type;

						match.unit.tags = JSON.parse(
							JSON.stringify({
								...(chapterValue != null && { chapter: chapterValue }),
								...(regionValue != null && { region: regionValue }),
								...(typeValue != null && { type: typeValue })
							})
						);
					}
				});

				// 翻譯新載入的資料
				if (i18n.locale === 'zh') {
					await translateMatches(matchesToProcess || [], 'zh-Hant')
				} else if (i18n.locale === 'en') {
					await translateMatches(matchesToProcess || [], 'en-US')
				} else if (i18n.locale === 'ja') {
					await translateMatches(matchesToProcess || [], 'ja')
				}
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error fetching get matches with filters:', error);
			} finally {
				if (isLoadMore) {
					this.isLoadingMore = false;
				} else {
					this.overlay = false;
					// 檢查是否為非付費會員，顯示提醒 dialog（track 20 除外）
					if (this.userDto.isPaidMember === false && this.trackDto?.id !== '20') {
						this.profileReminderDialog = true;
					}
				}
			}
		},
		async getFilterList() {
			let getMatchFilters
			try{
				// 先保存當前選擇的原始鍵值（不包含數字）
				const selectedCountryKeys = Object.entries(this.countryKeyValue ?? {})
					.filter(([key, value]) => this.countries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				const selectedIndustryKeys = Object.entries(this.industryKeyValue ?? {})
					.filter(([key, value]) => this.industries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});
				
				const selectedQueryKeys = Object.entries(this.queryKeyValue ?? {})
					.filter(([key, value]) => this.matchQueries?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				const selectedRegionKeys = Object.entries(this.regionKeyValue ?? {})
					.filter(([key, value]) => this.regions?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				const selectedTypeKeys = Object.entries(this.typeKeyValue ?? {})
					.filter(([key, value]) => this.types?.includes(value))
					.map(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						return match ? match[1] : key
					});

				let filterInput: FiltersInput = {
					countriesIso3: selectedCountryKeys,
					industries: selectedIndustryKeys,
					queries: selectedQueryKeys,
					// directions: this.matchDirections,
					regions: selectedRegionKeys,
					types: selectedTypeKeys,
					...(this.isHasStructuredProfile !== 'all' && {
						hasStructuredProfile: this.isHasStructuredProfile === 'true'
					})
				}
				// Only pass isHasStructuredProfile parameter if it's not 'all'
				// if (this.isHasStructuredProfile !== 'all') {
				// 	const isHasStructuredProfileBoolean = this.isHasStructuredProfile === 'true'
					getMatchFilters = await this.api$.businessMatchApi.getMatchFilters(
						this.user.userDto?.id as string, 
						filterInput,
						this.trackDto?.id ? this.trackDto.id : '0',
					)
				// } else {
				// 	// Call without the isHasStructuredProfile parameter
				// 	getMatchFilters = await this.api$.businessMatchApi.getMatchFilters(
				// 		this.user.userDto?.id as string, 
				// 		this.trackDto?.id ? this.trackDto.id : '0'
				// 	)
				// }
				this.matchFilterDto = getMatchFilters.data.data

				this.countryKeyValue = this.normalizeToKeyValue(this.matchFilterDto.countries) ?? {}
				this.industryKeyValue = this.normalizeToKeyValue(this.matchFilterDto.industries) ?? {}
				this.queryKeyValue = this.normalizeToKeyValue(this.matchFilterDto.queries) ?? {}
				this.regionKeyValue = this.normalizeToKeyValue(this.matchFilterDto.regions) ?? {}
				this.typeKeyValue = this.normalizeToKeyValue(this.matchFilterDto.types) ?? {}

				if (i18n.locale === 'zh') {
					await Promise.all([
						translateRecordValues(this.countryKeyValue, 'zh-Hant'),
						translateRecordValues(this.industryKeyValue, 'zh-Hant'),
						translateRecordValues(this.queryKeyValue, 'zh-Hant'),
						translateRecordValues(this.regionKeyValue, 'zh-Hant'),
						translateRecordValues(this.typeKeyValue, 'zh-Hant')
					])
				} else if (i18n.locale === 'en') {
					await Promise.all([
						translateRecordValues(this.countryKeyValue, 'en-US'),
						translateRecordValues(this.industryKeyValue, 'en-US'),
						translateRecordValues(this.queryKeyValue, 'en-US'),
						translateRecordValues(this.regionKeyValue, 'en-US'),
						translateRecordValues(this.typeKeyValue, 'en-US')
					])
				} else if (i18n.locale === 'ja') {
					await Promise.all([
						translateRecordValues(this.countryKeyValue, 'ja-JP'),
						translateRecordValues(this.industryKeyValue, 'ja-JP'),
						translateRecordValues(this.queryKeyValue, 'ja-JP'),
						translateRecordValues(this.regionKeyValue, 'ja-JP'),
						translateRecordValues(this.typeKeyValue, 'ja-JP')
					])
				}

				this.allCountries = Object.values(this.countryKeyValue ?? {})
				this.allMatchQueries = Object.values(this.queryKeyValue ?? {});
				this.allIndustries = Object.values(this.industryKeyValue ?? {})
				this.allRegions = Object.values(this.regionKeyValue ?? {})
				this.allTypes = Object.values(this.typeKeyValue ?? {})

				// 建立反向 map：翻譯後的文字 -> 英文原文
				this.translatedToOriginalIndustryMap = {}
				for (const [originalKey, translatedValue] of Object.entries(this.industryKeyValue)) {
					this.translatedToOriginalIndustryMap[translatedValue] = originalKey
				}

				// 重新映射選擇的項目到新的值（包含更新後的數字）
				this.countries = Object.entries(this.countryKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedCountryKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)

				this.industries = Object.entries(this.industryKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedIndustryKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)

				this.matchQueries = Object.entries(this.queryKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedQueryKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)

				this.regions = Object.entries(this.regionKeyValue ?? {})
					.filter(([key]) => {
						const match = key.match(/^(.+?) \((\d+)\)$/)
						const keyWithoutNumber = match ? match[1] : key
						return selectedRegionKeys.includes(keyWithoutNumber)
					})
					.map(([key, value]) => value)
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
		},
		async saveContact(item: Match){
			const userSavedContactCreation : UserSavedContactCreation = {
				matchId: item.id,
				unitId: item.unit?.id,
				productTrackId: this.trackDto?.id ? this.trackDto.id : '0'
			}
			try{
				await this.api$.savedContactApi.create(this.user.userDto?.id as string, userSavedContactCreation)
				// 直接更新對應項目的 savedContact 欄位
				const targetMatch = this.matchResults.matches?.find(m => m.id === item.id)
				if (targetMatch) {
					targetMatch.savedContact = true
				}
				// 如果 detailDrawer 開啟且是同一個項目，也更新 matchResultDetail
				if (this.matchResultDetail && this.matchResultDetail.id === item.id) {
					this.matchResultDetail.savedContact = true
				}
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error saving contact:', error);
			}
		},
		async deleteSavedContact(id: string | undefined, unitId: number | undefined){
			this.overlay = true
			try{
				await this.api$.savedContactApi.deleteByUserIdnProductTrackIdnUnitId(this.user.userDto?.id as string, this.trackDto?.id as string, unitId as number)
				// 直接更新對應項目的 savedContact 欄位
				const targetMatch = this.matchResults.matches?.find(m => m.id === id)
				if (targetMatch) {
					targetMatch.savedContact = false
				}
				// 如果 detailDrawer 開啟且是同一個項目，也更新 matchResultDetail
				if (this.matchResultDetail && this.matchResultDetail.id === id) {
					this.matchResultDetail.savedContact = false
				}
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error deleting saved contact:', error);
			}
			this.overlay = false
		},
		async getEmail(matchId){
			this.overlay = true
			let getRecommendedActionsResp
			try{
				getRecommendedActionsResp = await this.api$.businessMatchApi.getRecommendedActions(this.user.userDto?.id as string, matchId, localStorage.getItem('locale') ?? 'en', this.trackDto?.id? this.trackDto.id : '0')
				this.recommendedAction = getRecommendedActionsResp.data.data

				if(this.userDto.availabilityTime){
					await this.handleSaveFromChild(this.userDto.availabilityTime)
				} else{
					const editorInstance = this.$refs.markdownEditor as InstanceType<typeof Editor>;
					if(editorInstance){
						if(this.trackDto?.id == '7'){
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
							this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
						}
						editorInstance.invoke('setMarkdown', this.recommendedAction.text as string);
					}else{
						if(this.trackDto?.id == '7'){
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('bni', 'computex');
							this.recommendedAction.text = this.recommendedAction.text?.replaceAll('BNI', 'COMPUTEX');
							this.recommendedAction.title = this.recommendedAction.title?.replaceAll('BNI', 'COMPUTEX');
						}
						this.emailContentMarkdownForEdit = this.recommendedAction.text as string
					}
				}
				
				this.emailDialog = true
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
			this.overlay = false
		},
		async sendEmail(){
			this.overlay = true
			this.emailDialog = false

			const emailSendInput: EmailSendInput = {
				productTrackId: this.trackDto?.id ? this.trackDto.id : '0',
				userEmail: this.user.userDto?.email,
				to: this.matchResultDetail.unit?.email,
				matchId: this.matchResultDetail.id,
				subject: this.recommendedAction?.title,
				content: this.emailContentMarkdownForEdit,
			}

			let sendEmailResp
			try {
				sendEmailResp = await this.api$.businessMatchApi.sendEmail(this.user.userDto?.id as string, emailSendInput)

				this.emailSuccessDialog = true
			}catch (error) {
                this.costCode = costGuardCode(error)
				console.error(error);
			}
			this.overlay = false
		},
		async downloadCSV(){
			const trackId = this.trackDto?.id || ''
			const userId = this.user.userDto?.id;
			try {
				const downloadUrl = process.env.VUE_APP_API_BASE_URL+`/api/user/${userId}/business-match/download-match-results?productTrackId=${trackId}`;
				window.open(downloadUrl, '_blank');
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Error downloading CSV:', error);
			}
		},
		async handleRadioChange(value: string) {
			this.overlay = true
			this.countries = []
			this.industries = []
			this.matchQueries = []
			this.matchDirections = []
			this.regions = []
			await Promise.all([
				this.getFilterList(),
				this.refine(),
				this.getPlatformIndustryList()
			])
			this.overlay = false
		},
		linkifyText(text: string): string {
			const escaped = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
			return escaped.replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank" class="primary--text font-weight-medium" style="word-break: break-all;">$1</a>')
		},
		// 發送信件相關方法
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		async openSendEmailDialog(match: any) {
			// 先關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				// 先建立 sharing user 取得分享連結
				const userId = this.user.userDto?.id as string
				const response = await this.api$.sharingUserApi.createSharingUser(userId)
				const sharingId = response.data.data?.id

				// 若不是 localhost，在 // 和 ws 之間加入 trackDto.name.
				let baseUrl = process.env.VUE_APP_BASE_URL as string
				if (!baseUrl.includes('localhost') && this.trackDto?.name && this.trackDto?.id !== '0') {
					baseUrl = baseUrl.replace('//ws', `//${this.trackDto.name}.ws`)
				}
				this.sendEmailSharingUrl = `${baseUrl}/nl-match/profile-sharing/${sharingId}`
				this.sendEmailFixedContent = `[View Business Card →]: ${this.sendEmailSharingUrl}`

				this.sendEmailDialog = true
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Failed to create sharing user:', error)
			}
		},
		closeSendEmailDialog() {
			this.sendEmailDialog = false
		},
		async sendEmailToUnit() {
			if (!this.sendEmailSubject.trim() || !this.sendEmailContent.trim()) return

			// 先關閉 dialog
			this.closeSendEmailDialog()
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			this.overlay = true
			try {
				const fullContent = `${this.sendEmailContent}\n\n${this.sendEmailFixedContent}`

				const requestBody = {
					userId: this.user.userDto?.id as string,
					unitId: this.matchResultDetail.unitId,
					productTrackId: this.trackDto?.id,
					subject: this.sendEmailSubject,
					content: fullContent,
					matchId: this.matchResultDetail.id
				}

				await this.api$.emailApi.sendEmailToUnit(requestBody)

				// 清空主旨和信件內容
				this.sendEmailSubject = ''
				this.sendEmailContent = ''
				this.sendEmailFixedContent = ''

				// 顯示成功訊息
				this.snackbarColor = '#1976D1'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessAddedTo'))
				this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessMyContacts'))
				this.snackbarLinkRoute = '/match/my-contacts'
				this.snackbarTextAfter = String(this.$t('businessMatchResults.detailDrawer.connectSuccessNotifiedByEmail'))
				this.snackbar = true
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Failed to send email:', error)
				// 顯示失敗訊息
				this.snackbarColor = 'error'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.emailSendFailed'))
				this.snackbarLinkText = ''
				this.snackbarTextAfter = ''
				this.snackbar = true
			} finally {
				this.overlay = false
			}
		},
		async addUnitAsFriend(unitId: number) {
			const userId = this.user.userDto?.id as string
			if (!userId || !unitId) return null

			try {
				const response = await this.api$.userFriendApi.addUnitAsFriend(userId, unitId)
				return response.data.data
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Failed to add unit as friend:', error)
				return null
			}
		},
		async sendTemplateEmail(input: SendMarkdownEmailInput) {
			try {
				await this.api$.emailApi.sendEmail1(input)
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('Failed to send email:', error)
			}
		},
		async handleConnect(match: Match, source = 'results_card') {
            if (this.isPublicIntro) { this.openIntroForm(match, source); return }
			const unitId = match.unit?.id
			const productTrackId = match.unit?.productTrackId

			if (!unitId) return

			// 檢查使用者個人資料是否完整
			if (!this.userDto?.companyTitle || !this.userDto?.email || !this.userDto?.companyName) {
				this.snackbarColor = 'warning'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.incompleteProfile'))
				this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.goToProfile'))
				this.snackbarLinkRoute = '/profile'
				this.snackbarTextAfter = ''
				this.snackbar = true
				return
			}

			// 若已聯繫過，顯示提示訊息並返回
			if (match.savedContact === true) {
				this.snackbarColor = '#1976D1'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.alreadyContacted'))
				this.snackbarLinkText = ''
				this.snackbarLinkRoute = ''
				this.snackbarTextAfter = ''
				this.snackbar = true
				return
			}

			this.overlay = true

			// 關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				if (productTrackId === '0') {
					const toEmail = match.unit?.email

					// 同時呼叫 saveContact、addUnitAsFriend，有 email 時也一起建立 sharingUser
					const userId = this.user.userDto?.id as string
					const promises: Promise<any>[] = [
						this.saveContact(match),
						this.addUnitAsFriend(unitId)
					]
					if (toEmail) {
						promises.push(this.api$.sharingUserApi.createSharingUser(userId))
					}
					const results = await Promise.all(promises)

					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const userName = `${match.unit?.firstName || ''} ${match.unit?.lastName || ''}`.trim()

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.connectUser.subject'))
						let content = String(this.$t('emailTemplates.connectUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						content = content
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)

						// 條件式行：Title
						if (senderTitle) {
							content = content.replace(/\{sender_title\}/g, senderTitle)
						} else {
							content = content.replace(/\n- Title: \{sender_title\}/g, '')
						}

						// 條件式行：Looking for
						if (senderLookingFor) {
							content = content.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							content = content.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式行：Offers
						if (senderOffers) {
							content = content.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							content = content.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// [Login to Accept →] 後面加入 NonLoginChatRoom 連結
						content = content.replace('[Login to Accept →]', `[Login to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content
						})
					}

					// 標記為已聯繫
					match.savedContact = true

					// 顯示成功訊息
					this.snackbarColor = '#1976D1'
					this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessConnected'))
					this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessStartConversation'))
					this.snackbarLinkRoute = '/chat'
					this.snackbarTextAfter = ''
					this.snackbar = true
				} else {
					const toEmail = match.unit?.email

					// 同時呼叫 saveContact
					const promises: Promise<any>[] = [
						this.saveContact(match)
					]
					await Promise.all(promises)

					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const trackId = this.trackDto?.id ?? ''
						let userName = ''
						if (['4', '7'].includes(trackId)) {
							userName = match.unit?.entityName || ''
						} else {
							userName = `${match.unit?.firstName || ''} ${match.unit?.lastName || ''}`.trim()
						}

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderIndustry = userDto?.companyIndustry?.join(', ') || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''
						const senderMatchReasonItems = match.summaries?.filter(Boolean) || []
						const senderMatchReason = senderMatchReasonItems.length > 0 ? '\n  - ' + senderMatchReasonItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.connectNonUser.subject'))
						let content = String(this.$t('emailTemplates.connectNonUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						content = content
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)
							.replace(/\{sender_industry\}/g, senderIndustry)

						// 條件式行：Title（在 greeting 行中）
						if (senderTitle) {
							content = content.replace(/\{sender_title\}/g, senderTitle)
						} else {
							content = content.replace(/, \{sender_title\}/g, '')
						}

						// 條件式行：Looking for
						if (senderLookingFor) {
							content = content.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							content = content.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式行：Offers
						if (senderOffers) {
							content = content.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							content = content.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// Why they want to connect
						if (senderMatchReason) {
							content = content.replace(/\{sender_match_reason\}/g, senderMatchReason)
						} else {
							content = content.replace(/\n- Why they want to connect: \{sender_match_reason\}/g, '')
						}

						// [Register to Accept →] 後面加入 NonLoginChatRoom 連結
						content = content.replace('[Register to Accept →]', `[Register to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content
						})
					}

					// 標記為已聯繫
					match.savedContact = true

					// 顯示成功訊息
					this.snackbarColor = '#1976D1'
					this.snackbarLinkText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessMyContacts'))
					this.snackbarLinkRoute = '/match/my-contacts'
					if (toEmail) {
						this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessAddedTo'))
						this.snackbarTextAfter = String(this.$t('businessMatchResults.detailDrawer.connectSuccessNotifiedByEmail'))
					} else {
						this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectSuccessConnectedAddedTo'))
						this.snackbarTextAfter = ''
					}
					this.snackbar = true
				}
			} catch (error) {
                this.costCode = costGuardCode(error)
				console.error('handleConnect failed:', error)
				// 顯示錯誤訊息
				this.snackbarColor = 'error'
				this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectFailed') || 'Connect failed')
				this.snackbarLinkText = ''
				this.snackbarLinkRoute = ''
				this.snackbarTextAfter = ''
				this.snackbar = true
			} finally {
				this.overlay = false
			}
		},
		async handleMessage(match: Match) {
			const unitId = match.unit?.id
			const productTrackId = match.unit?.productTrackId

			if (!unitId) return

			this.overlay = true

			// 關閉抽屜
			this.detailDrawer = false
			this.mobileDetailDrawer = false

			try {
				if (productTrackId === '0') {
					const toEmail = match.unit?.email

					// 同時呼叫 saveContact、addUnitAsFriend，有 email 時也一起建立 sharingUser
					const userId = this.user.userDto?.id as string
					const promises: Promise<any>[] = [
						this.saveContact(match),
						this.addUnitAsFriend(unitId)
					]
					if (toEmail) {
						promises.push(this.api$.sharingUserApi.createSharingUser(userId))
					}
					const [, friendResponse, ...rest] = await Promise.all(promises)

					// 寄送 messageUser 模板信件
					if (toEmail) {
						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const userName = `${match.unit?.firstName || ''} ${match.unit?.lastName || ''}`.trim()

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''
						const senderLookingForItems = userDto?.demands?.map(d => d.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderLookingFor = senderLookingForItems.length > 0 ? '\n  - ' + senderLookingForItems.join('\n  - ') : ''
						const senderOffersItems = userDto?.supplies?.map(s => s.descriptionShort).filter(Boolean).slice(0, 2) || []
						const senderOffers = senderOffersItems.length > 0 ? '\n  - ' + senderOffersItems.join('\n  - ') : ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.messageUser.subject'))
						let emailContent = String(this.$t('emailTemplates.messageUser.content'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						emailContent = emailContent
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_company\}/g, senderCompany)

						// 條件式：Title
						if (senderTitle) {
							emailContent = emailContent.replace(/\{sender_title\}/g, senderTitle)
						} else {
							emailContent = emailContent.replace(/\n- Title: \{sender_title\}/g, '')
						}

						// 條件式：Looking for
						if (senderLookingFor) {
							emailContent = emailContent.replace(/\{sender_looking_for\}/g, senderLookingFor)
						} else {
							emailContent = emailContent.replace(/\n- Looking for: \{sender_looking_for\}/g, '')
						}

						// 條件式：Offers
						if (senderOffers) {
							emailContent = emailContent.replace(/\{sender_offers\}/g, senderOffers)
						} else {
							emailContent = emailContent.replace(/\n- Offers: \{sender_offers\}/g, '')
						}

						// 替換連結（使用 NonLoginChatRoom URL）
						emailContent = emailContent.replace('[Login to Accept →]', `[Login to Accept →]: ${nonLoginChatUrl}`)

						// 發送信件
						await this.sendTemplateEmail({
							toAddrs: [toEmail],
							subject,
							content: emailContent
						})
					}

					// 跳轉到 chat
					if (friendResponse?.friendUserId) {
						localStorage.setItem('TARGET_USER_ID', friendResponse.friendUserId)
						this.$router.push('/chat')
					}
				} else {
					const toEmail = match.unit?.email

					// 同時呼叫 saveContact，有 email 時也一起建立 sharingUser
					const userId = this.user.userDto?.id as string
					const promises: Promise<any>[] = [
						this.saveContact(match)
					]
					if (toEmail) {
						promises.push(this.api$.sharingUserApi.createSharingUser(userId))
					}
					const results = await Promise.all(promises)

					if (toEmail) {
						const sharingResponse = results[1]
						const sharingId = sharingResponse.data.data?.id
						let baseUrl = process.env.VUE_APP_BASE_URL as string
						if (!baseUrl.includes('localhost') && this.trackDto?.name && this.trackDto?.id !== '0') {
							baseUrl = baseUrl.replace('//ws', `//${this.trackDto.name}.ws`)
						}
						const sharingUrl = `${baseUrl}/nl-match/profile-sharing/${sharingId}`

						// NonLoginChatRoom URL
						const nonLoginChatUrl = `${process.env.VUE_APP_NONLOGIN_CHAT_URL}/${this.user.userDto?.id}`

						// 取得收件者名稱
						const trackId = this.trackDto?.id ?? ''
						let userName = ''
						if (['4', '7'].includes(trackId)) {
							userName = match.unit?.entityName || ''
						} else {
							userName = `${match.unit?.firstName || ''} ${match.unit?.lastName || ''}`.trim()
						}

						// 取得寄件者資訊
						const userDto = this.user.userDto
						const senderName = `${userDto?.firstName || ''} ${userDto?.lastName || ''}`.trim()
						const senderTitle = userDto?.companyTitle?.join(', ') || ''
						const senderCompany = userDto?.companyName || ''

						// 取得模板
						let subject = String(this.$t('emailTemplates.messageNonUser.subject'))
						let templateContent = String(this.$t('emailTemplates.messageNonUser.content'))
						let fixedContent = String(this.$t('emailTemplates.messageNonUser.fixedContent'))

						// 替換變數
						subject = subject.replace(/\{sender_name\}/g, senderName)
						templateContent = templateContent
							.replace(/\{user_name\}/g, userName)
							.replace(/\{sender_name\}/g, senderName)
							.replace(/\{sender_title\}/g, senderTitle)
							.replace(/\{sender_company\}/g, senderCompany)

						// 替換連結
						templateContent = templateContent.replace('[View Business Card →]', `[View Business Card →]: ${sharingUrl}`)
						fixedContent = fixedContent.replace('[Register to Message →]', `[Register to Message →]: ${nonLoginChatUrl}`)

						// 帶入主旨、內文、固定區塊
						this.sendEmailSubject = subject
						this.sendEmailContent = templateContent
						this.sendEmailFixedContent = fixedContent
						this.sendEmailSharingUrl = sharingUrl

						// 打開 dialog
						this.sendEmailDialog = true
					}
				}
			} finally {
				this.overlay = false
			}
		}
	},
	async created(){
		this.overlay = true
        this.matchContextReady = this.getMatchRequest();

		await Promise.all([
			this.matchContextReady,
			this.getMatches(),
			this.getFilterList(),
			this.getMe(),
			this.getPlatformIndustryList()
		])

		// 在 getPlatformIndustryList() 完成後，將英文的行業名稱轉換為當前語言
		if (this.userDto.companyIndustry && this.userDto.companyIndustry.length > 0) {
			this.industry = this.userDto.companyIndustry.map(englishIndustry => {
				// platformIndustryKeyValue 的 key 是英文原文，value 是翻譯後的文字
				return this.platformIndustryKeyValue[englishIndustry] || englishIndustry
			})
		}

		await this.$nextTick()

		if(localStorage.getItem('MATCH_RESULTS_ID')){
			const matchId = localStorage.getItem('MATCH_RESULTS_ID') as string
			const action = localStorage.getItem('ACTION')

			// 先清除 localStorage，避免重複執行
			localStorage.removeItem('MATCH_RESULTS_ID')
			localStorage.removeItem('ACTION')

			this.scrollToMatch(matchId)
			const matchResult = this.matchResults.matches?.find(match => match.id === matchId)

			if(matchResult && action === 'save-contact'){
				try {
					await this.handleConnect(matchResult)
				} catch (error) {
                this.costCode = costGuardCode(error)
					console.error('Auto handleConnect failed:', error)
					// 即使失敗也顯示提示
					this.snackbarColor = 'error'
					this.snackbarText = String(this.$t('businessMatchResults.detailDrawer.connectFailed') || 'Connect failed')
					this.snackbarLinkText = ''
					this.snackbarLinkRoute = ''
					this.snackbarTextAfter = ''
					this.snackbar = true
				}
			}else if(matchResult && action === 'view-contacts'){
				this.matchResultDetail = matchResult
				this.detailDrawer = true
				this.mobileDetailDrawer = true
			}
		}
		this.overlay = false

		// 等 overlay 結束後再顯示 profileReminderSnackbar
		if(this.pendingProfileReminderSnackbar){
			this.profileReminderSnackbar = true
			this.pendingProfileReminderSnackbar = false
		}
	},
	mounted() {
		// 監聯搜尋事件
		this.eventHub$.$on('searchStarted', this.onSearchStarted)
		this.eventHub$.$on('searchFinished', this.onSearchFinished)
	},
	beforeDestroy() {
        this.publicResultsDestroyed = true;
        this.publicResultSequence++;
		// 移除 eventHub 監聽器
		this.eventHub$.$off('searchStarted', this.onSearchStarted)
		this.eventHub$.$off('searchFinished', this.onSearchFinished)
	},
	watch: {
		'$i18n.locale': {
			immediate: false,
			async handler() {
                this.publicResultSequence++;
				this.overlay = true
				
				// 只翻譯現有資料，不重新呼叫 API
				if (this.matchResults.matches && this.matchResults.matches.length > 0) {
					if (i18n.locale === 'zh') {
						await translateMatches(this.matchResults.matches, 'zh-Hant')
					} else if (i18n.locale === 'en') {
						await translateMatches(this.matchResults.matches, 'en-US')
					} else if (i18n.locale === 'ja') {
						await translateMatches(this.matchResults.matches, 'ja')
					}
				}
				
				// 翻譯 filter 資料
				if (this.matchFilterDto) {
					const selectedCountryKeys = Object.entries(this.countryKeyValue ?? {})
						.filter(([key, value]) => this.countries?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});

					const selectedIndustryKeys = Object.entries(this.industryKeyValue ?? {})
						.filter(([key, value]) => this.industries?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});
					
					const selectedQueryKeys = Object.entries(this.queryKeyValue ?? {})
						.filter(([key, value]) => this.matchQueries?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});

					const selectedRegionKeys = Object.entries(this.regionKeyValue ?? {})
						.filter(([key, value]) => this.regions?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});

					const selectedTypeKeys = Object.entries(this.typeKeyValue ?? {})
						.filter(([key, value]) => this.types?.includes(value))
						.map(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							return match ? match[1] : key
						});

					if (i18n.locale === 'zh') {
						await Promise.all([
							translateRecordValues(this.countryKeyValue, 'zh-Hant'),
							translateRecordValues(this.industryKeyValue, 'zh-Hant'),
							translateRecordValues(this.queryKeyValue, 'zh-Hant'),
							translateRecordValues(this.regionKeyValue, 'zh-Hant'),
							translateRecordValues(this.typeKeyValue, 'zh-Hant')
						])
					} else if (i18n.locale === 'en') {
						await Promise.all([
							translateRecordValues(this.countryKeyValue, 'en-US'),
							translateRecordValues(this.industryKeyValue, 'en-US'),
							translateRecordValues(this.queryKeyValue, 'en-US'),
							translateRecordValues(this.regionKeyValue, 'en-US'),
							translateRecordValues(this.typeKeyValue, 'en-US')
						])
					} else if (i18n.locale === 'ja') {
						await Promise.all([
							translateRecordValues(this.countryKeyValue, 'ja-JP'),
							translateRecordValues(this.industryKeyValue, 'ja-JP'),
							translateRecordValues(this.queryKeyValue, 'ja-JP'),
							translateRecordValues(this.regionKeyValue, 'ja-JP'),
							translateRecordValues(this.typeKeyValue, 'ja-JP')
						])
					}

					this.allCountries = Object.values(this.countryKeyValue ?? {})
					this.allMatchQueries = Object.values(this.queryKeyValue ?? {});
					this.allIndustries = Object.values(this.industryKeyValue ?? {})
					this.allRegions = Object.values(this.regionKeyValue ?? {})
					this.allTypes = Object.values(this.typeKeyValue ?? {})

					// 建立反向 map：翻譯後的文字 -> 英文原文
					this.translatedToOriginalIndustryMap = {}
					for (const [originalKey, translatedValue] of Object.entries(this.industryKeyValue)) {
						this.translatedToOriginalIndustryMap[translatedValue] = originalKey
					}

					// 重新映射選擇的項目到新的值（包含更新後的數字）
					this.countries = Object.entries(this.countryKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedCountryKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)

					this.industries = Object.entries(this.industryKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedIndustryKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)

					this.matchQueries = Object.entries(this.queryKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedQueryKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)

					this.regions = Object.entries(this.regionKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedRegionKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)

					this.types = Object.entries(this.typeKeyValue ?? {})
						.filter(([key]) => {
							const match = key.match(/^(.+?) \((\d+)\)$/)
							const keyWithoutNumber = match ? match[1] : key
							return selectedTypeKeys.includes(keyWithoutNumber)
						})
						.map(([key, value]) => value)
				}

				// 在 getPlatformIndustryList() 完成後，將英文的行業名稱轉換為當前語言
				if (this.userDto.companyIndustry && this.userDto.companyIndustry.length > 0) {
					this.industry = this.userDto.companyIndustry.map(englishIndustry => {
						// platformIndustryKeyValue 的 key 是英文原文，value 是翻譯後的文字
						return this.platformIndustryKeyValue[englishIndustry] || englishIndustry
					})
				}
				
				this.overlay = false
			}
		}
	}
});
